import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Import useTranslation

import PieChart from "../StatsChart/PieChart";
import LineGraph from "../StatsChart/LineGraph";
import StackedBarChart from "../StatsChart/StackedBarChart";

const YearView = ({ date, expensesItems, setViewMode, setCurrentDate }) => {
  const { t } = useTranslation(); // Initialize useTranslation hook
  const year = date.getFullYear();

  // Get all months of the year
  const monthsArray = Array.from({ length: 12 }, (_, i) => new Date(year, i));

  const yearItems = expensesItems.filter((item) => new Date(item.purchasedDate).getFullYear() === year);
  // Calculate total amount for the year
  const totalYearAmount = yearItems.reduce((total, item) => total + Number(item.total || 0), 0);
  const intervals = Array.from({ length: 12 }, (_, i) => ({
    start: new Date(year, i, 1),
    end: new Date(year, i + 1, 0),
  }));
  console.log({ totalYearAmount });
  return (
    <div>
      <h3>
        {year} - {t("statistics.yearViewComp.total", { totalAmount: totalYearAmount.toFixed(2) })}
      </h3>
      <Row>
        {monthsArray.map((month) => {
          const formattedMonth = month.toISOString().split("T")[0].slice(0, 7);
          const itemsForMonth = expensesItems.filter((item) => item.purchasedDate?.startsWith(formattedMonth));
          const totalAmount = itemsForMonth.reduce((total, item) => total + Number(item.total || 0), 0);
          if (totalAmount === 0) {
            return;
          }
          return (
            <Col key={month} xs={6} sm={4} md={3} lg={2}>
              <Card
                className="mb-3"
                onClick={() => {
                  setViewMode("month");
                  setCurrentDate(month);
                }}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="text-center">
                  <p>{month.toLocaleString("default", { month: "long" })}</p>
                  <p>{t("statistics.yearViewComp.total", { totalAmount: totalAmount.toFixed(2) })}</p>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row className="mt-4 g-4">
        <Col lg={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5 className="mb-3">{t("statistics.yearViewComp.categoryBreakdown")}</h5>
              <PieChart items={yearItems} />
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5 className="mb-3">{t("statistics.yearViewComp.spendingTrends")}</h5>
              <LineGraph items={yearItems} intervals={intervals} />
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5 className="mb-3">{t("statistics.yearViewComp.stackedOverview")}</h5>
              <StackedBarChart items={yearItems} intervals={intervals} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default YearView;
